import React from 'react';
import ColorPalette from './components/ColorPalette';
import UIElements from './components/UIElements';
import BrandValues from './components/BrandValues';
import './styles/brandGuidelines.css';

const BrandGuidelines = () => {
    return (
        <div className="brand-guidelines">
            <h1>Brand Guidelines</h1>
            <ColorPalette />
            <UIElements />
            <BrandValues />
        </div>
    );
};

export default BrandGuidelines;